import { useEffect } from 'react';
import type { BiometricType } from '../../../../../../auth/nocode/types';
import { useGetUserContext } from '../../../../../hooks/useGetUserContext';
import { getBiometricInfo } from '../../../../../hooks/useGlobalBlockActions/actions/manageBiometrics/hooks/useBiometric';
import { useGetGlobalAppStateStoreState } from '../../../../../stores/app/GlobalAppStateStore';
import { useSetDeviceContext } from '../helperHooks/useSetDeviceContext';

export function useBiometrics() {
  const { getGlobalAppStateStoreState } = useGetGlobalAppStateStoreState();
  const { setDeviceContext } = useSetDeviceContext();
  const { userContext } = useGetUserContext();

  // biome-ignore lint/correctness/useExhaustiveDependencies: userContext is a deliberate extra dependency — re-running on user-context changes retries a transiently failed biometric read while the slice is still unset (the store guard makes retries no-ops once populated)
  useEffect(() => {
    const initializeBiometrics = async () => {
      if (getGlobalAppStateStoreState().deviceContext.biometric) {
        return;
      }

      let biometricInfo: Awaited<ReturnType<typeof getBiometricInfo>>;
      try {
        biometricInfo = await getBiometricInfo();
      } catch (error) {
        console.error('[Biometrics] failed to read biometric info:', error);
        return;
      }

      setDeviceContext({
        biometric: {
          available: biometricInfo.available,
          biometryType: biometricInfo.biometryType as BiometricType,
        },
      });
    };
    void initializeBiometrics();
  }, [getGlobalAppStateStoreState, userContext, setDeviceContext]);
}
